var marker = null;
var map = null;
var geocoder = null;

function initializeMap(
  mapElementSelector,
  latInputElementSelector,
  lngInputElementSelector
) {
  var latlng = new google.maps.LatLng(49.260635, 10.986328);
  var mapOptions = {
    zoom: 6.4,
    center: latlng,
    mapTypeId: google.maps.MapTypeId.TERRAIN,
    streetViewControl: false,
    draggableCursor: 'crosshair'
  };

  map = new google.maps.Map($(mapElementSelector)[0], mapOptions);
  google.maps.event.addListener(map, 'click', function (event) {
    placeMarker(event.latLng, latInputElementSelector, lngInputElementSelector);
  });

  var lat = $(latInputElementSelector).val();
  var lng = $(lngInputElementSelector).val();
  if (lat && lng) {
    var loc = new google.maps.LatLng(lat, lng);
    placeMarker(loc, latInputElementSelector, lngInputElementSelector);
  }
}

function placeMarker(
  location,
  latInputElementSelector,
  lngInputElementSelector
) {
  if (marker != null) {
    marker.setMap(null);
    marker = null;
  }

  $('location').value = location;
  marker = new google.maps.Marker({
    position: location,
    map: map
  });

  var icon = {
    path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
    fillColor: '#FF0000',
    fillOpacity: 1,
    anchor: new google.maps.Point(12, 22),
    strokeWeight: 2,
    strokeColor: '#fff',
    scale: 2
  };

  marker.setIcon(icon);

  $(latInputElementSelector).val(location.lat()).trigger('input');
  $(lngInputElementSelector).val(location.lng()).trigger('input');
}

function searchLoc(query) {
  if (geocoder == null) {
    geocoder = new google.maps.Geocoder();
  }

  geocoder.geocode({ address: query }, function (results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      var bounds = results[0].geometry.bounds;
      map.fitBounds(bounds);
    }
  });
}

$(function () {
  $('.map__search-input').on('keydown', function (e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      searchLoc($(this).val());
    }
  });

  $('.map__search-button').on('click', function () {
    searchLoc($(this).parent().find('.map__search-input').val());
  });

  $('.input-lat-lng__toggle-map').on('click', function () {
    $('.input-lat-lng__wrapper').toggleClass('input-lat-lng__wrapper--map-active');
    if ($('.input-lat-lng__wrapper').hasClass('input-lat-lng__wrapper--map-active')) {
      $('.map__wrapper').slideDown(250);
    } else {
      $('.map__wrapper').slideUp(250);
    }
  });
});
